
import BasicState from "@libs/basic-view"

class HTMLView extends BasicState {
	 
}
export default HTMLView
